module.exports = __webpack_public_path__ + "f3ddbbed4e4b2efb3ccd6de7d5580051.svg";